/* Amazon module */

import uiRouter from '@uirouter/angularjs';

import { AppShellModule } from 'components/appShell/appShell.module';
import { AppsServiceModule } from '../../services/data/apps.service';


import './amazon.scss';

export const AmazonModule = angular
    .module('app.pages.amazon', [
        uiRouter,
        AppShellModule,
        AppsServiceModule
    ]).config(($stateProvider) => {
        'ngInject';

        $stateProvider.state({
            parent: 'apps',
            name: 'amazon',
            url: '/amazon',
            component: 'appShell',
            params: {
                queryString: null
            },
            resolve: {
                title: () => { return 'Amazon'; },
                trackingId: () => { return 'Amazon'; },
                src: (appsService, authTokenService, $q, $stateParams) => {
                    return $q.all([
                        appsService.getApps(),
                        appsService.getAppToken('Sr3iikb5vPhglN5X76J2ZLRgygbzyQWcCvJaz1CbV8judBuuyZ358z97PpmRehXuDd-pC6asA2_rXDxgQA8E6w'), // eslint-disable-line max-len
                        authTokenService.getTenantId()
                    ])
                        .then(([apps, token, tenant]) => {
                            let uri = '';
                            apps.forEach((app) => {
                                if (app.sku === 'amazon') {
                                    uri = `${app.uri}#connect/volusion?tenant=${tenant}&token=${token}`; //eslint-disable-line
                                    if ($stateParams.queryString) {
                                        uri = `${uri}&${$stateParams.queryString}`;
                                    }
                                }
                            });
                            return uri;
                        });
                }
            },
            data: {
                page: 'amazon'
            }
        });
    }).name;



// WEBPACK FOOTER //
// ./src/app/pages/amazon/amazon.module.js